/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ID, WithVersion } from '@gh/common-shared-data';

import { DrawInvoiceStatus, InvoicePhysicalType, InvoiceType } from '../job-draws';

export type JobFinancialsDto = WithVersion<{
  jobId?: ID;
  invoices: JobFinancialsDrawDto[];
  jobNumber?: number;
  customerId?: ID;
  jobExpenses: JobFinancialsExpenseDto[];
  siteAddress?: string;
  customerName?: string;
  revisedBudget?: number;
  contractAmount?: number;
  variationsAmount?: number;
  invoicesAmount?: number;
  reportUrl?: string;
}>;

export type JobFinancialsDrawDto = {
  amount: number;
  amountWithGst: number;
  invoiceNumber: number;
  accountingDate: Date;
  variationId?: ID;
  drawRuleStage: number;
  drawRuleId: ID;
  drawRuleName: string;
  invoiceId: ID;
  type: InvoiceType;
  description: string;
  statusDescription: string;
  balance: number;
  externalId?: ID;
  xeroUrl?: string;
  payments: JobFinancialDrawPaymentDto[];
  invoiceType: InvoicePhysicalType;
  isNotOpening: boolean;
  status: DrawInvoiceStatus;
  isCreatedFromChangeOrder: boolean;
};

export type JobFinancialDrawPaymentDto = {
  invoiceId: ID;
  paymentId: ID;
  paidDate: Date;
  amount: number;
  reference: string;
};

export type JobFinancialsExpenseDto = {
  costCenterId: ID;
  costCenterCode?: number;
  costCenterName: string;
  budgetCost: number;
  actualCost: number;
  variance: number;
};

export enum InvoiceStatus {
  Draft = 1,
  Submitted = 2,
  Authorized = 3,
  Deleted = 4,
  Voided = 5,
  Paid = 6,
}
